import { company_name } from "@/i18n/variables";

const not_available_card = {
	button: `Go to ${company_name} Announcements`,
	title: "NOT AVAILABLE",
};

export default not_available_card;
